// extracted by mini-css-extract-plugin
export default {"modal":"YouTubeModal_modal__J6hoW","title":"YouTubeModal_title__NHvkh","buttons":"YouTubeModal_buttons__2-8Nf"};